import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import "./Blogs.css";

function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const IMAGE_URL = "https://aethearia.store/superadmin/uploads/blogs/";

  const fetchBlogs = async () => {
    try {
      const res = await fetch(
        "https://aethearia.store/superadmin/api/blogList"
      );

      const data = await res.json();

      console.log("Blog List:", data);

      if (data.status) {
        setBlogs(data.data || []);
      } else {
        setBlogs([]);
      }
    } catch (error) {
      console.log("Blog list error:", error);
      setBlogs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    return date.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const handleBlogClick = (slug) => {
    window.location.href = `/blogs/${slug}`;
  };

  return (
    <>
      <Header />

      <main className="blogs-page">
        <section className="blogs-top">
          <h1>Blogs</h1>
        </section>

        {loading ? (
          <div className="no-blogs">
            <h2>Loading blogs...</h2>
          </div>
        ) : blogs.length > 0 ? (
          <section className="blogs-grid">
            {blogs.map((blog) => (
              <article
                className="blog-card"
                key={blog.id}
                onClick={() => handleBlogClick(blog.slug)}
              >
                <div className="blog-meta">
                  <span>Blog</span>
                  <span>|</span>
                  <span>{formatDate(blog.blogdate)}</span>
                </div>
                <div >
                <div className="blog-img-box">
                  <img
                    src={`${IMAGE_URL}${blog.image}`}
                    alt={blog.blogtitle}
                    onError={(e) => {
                      e.currentTarget.src = "/blogs/default-blog.jpg";
                    }}
                  />
                </div>
                <div class ="blog-content">
                    <h2>{blog.blogtitle}</h2>

                {blog.short_desc && <p>{blog.short_desc}</p>}
                </div>
                </div>
                
              </article>
            ))}
          </section>
        ) : (
          <div className="no-blogs">
            <h2>No blogs found</h2>
            <p>No blog posts are available right now.</p>
          </div>
        )}
      </main>

      <Footer />
    </>
  );
}

export default Blogs;